import ImportQuestions from "pages/dashboard/shared/ImportQuestions";

const SchoolImportQuestion = () => {
  return <ImportQuestions />;
};

export default SchoolImportQuestion;
